import { render, staticRenderFns } from "./EnrichmentStep.vue?vue&type=template&id=0c8615a0"
import script from "./EnrichmentStep.ts?vue&type=script&lang=ts&external"
export * from "./EnrichmentStep.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8615a0')) {
      api.createRecord('0c8615a0', component.options)
    } else {
      api.reload('0c8615a0', component.options)
    }
    module.hot.accept("./EnrichmentStep.vue?vue&type=template&id=0c8615a0", function () {
      api.rerender('0c8615a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Steps/EnrichmentStep.vue"
export default component.exports